import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from '@exchange/environment'
import { IClaimAdjustedReceivedDate, IClaimDelete } from '../domain'

@Injectable()
export class ClaimUpdateService {
  constructor(private http: HttpClient) {}
  baseUri = `${environment.tmapiroot}/ClaimsUpdate`

  postClaimDelete(model: IClaimDelete): Observable<any> {
    return this.http.post(`${this.baseUri}/Delete`, model).pipe(map((response: any) => response))
  }

  postClaimAdjustedDate(model: IClaimAdjustedReceivedDate): Observable<any> {
    return this.http
      .post(`${this.baseUri}/AdjustDate`, model)
      .pipe(map((response: any) => response))
  }
}
